export default "__VITE_ASSET__CgQPef4j__"